module.exports = __webpack_public_path__ + "static/media/recutment_candidate.3d27f180.gif";